module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAgCAYAAACowdDWAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAECSURBVHgB3dndDYMgFAVg2KAjOEJHcQMZrSN0g45iN3AEek0kqQ/qPcjf4SQGjZcLX4y+aE2heO8fMjg51vFlrf2aniLApxyL32cyveQA2A/0AsgPVQJ5oSCQDxoJ5IEqgbzvqBLoPOvHSAsE69uBokBwXn1oLBCcXw96Fwj2KQ9NBQT7lYOmBoJ980NzAcH++aC5geA66aGlgOB66aClgeC696G1gOD68dDaQHAfOLQVILgfPbQ1ILiva2irQHB/090GzlRONJQFGAJD5WJgAoZAUDn5sAFDFNAlFM6MwBAFdDh7ks6Q5AQ6/xfMrMCQA8e43rNbwSDDuNW/WX+rHTl+oG7ugx3GF+sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Vector.png
// module id = 8MlE
// module chunks = 4